import GameForms from "./forms";
import { gameUseMutation } from "./hooks";

const Game = { Forms: GameForms, Hooks: gameUseMutation };

export default Game;
